import styled from "styled-components";
import colors from "../../../../../css/colors";

export const CenterContentWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

interface ActionLinkProps {
  disabled?: boolean;
}

export const ActionLink = styled.span<ActionLinkProps>`
  color: ${(props) => (props.disabled ? colors.GREY : "#ff3a52")};

  &:hover {
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
    text-decoration: ${(props) => (props.disabled ? "initial" : "underline")};
  }
`;

interface QuantityFieldProps {
  invalid?: boolean;
}

export const QuantityField = styled.input<QuantityFieldProps>`
  padding: 0 0 0 16px;
  width: 88px;
  background-color: ${(props) => (props.invalid ? "#FFF3F5" : "white")};
  border: ${(props) => (props.invalid ? "1px solid #FF3A52" : "1px solid #BDBDBD")};
  border-radius: 6px;
  font-size: 13px;
  text-align: center;
`;
